import React from 'react';
import { Reveal } from './Reveal';
import { ArrowRightIcon, CheckIcon, ShieldCheckIcon, DownloadIcon, SmartphoneIcon } from 'lucide-react';
const COVER = 'https://cdn.magicpatterns.com/uploads/krjkWXMhN4jKdhLjworVSd/Portada.png';
const CHECKOUT_URL = 'https://descubretumundointerior.com//cart/48128506855682:1';
export function Offer() {
  return <section id="oferta" className="relative w-full scroll-mt-6 overflow-hidden bg-ink py-24" data-id="element-95">
      <div className="pointer-events-none absolute left-1/2 top-0 h-96 w-96 -translate-x-1/2 rounded-full bg-rose-glow/20 blur-[130px]" data-id="element-96" />

      <div className="relative mx-auto max-w-4xl px-6" data-id="element-97">
        <Reveal data-id="element-98">
          <div className="overflow-hidden rounded-3xl border border-rose-glow/25 bg-indigo-deep/60" data-id="element-99">
            <div className="grid grid-cols-1 md:grid-cols-[0.9fr_1.1fr]" data-id="element-100">
              <div className="hidden items-center justify-center bg-black/20 p-8 md:flex" data-id="element-101">
                <img src={COVER} alt="Portada del eBook El Mapa de los Casi Algo" className="w-full max-w-[240px] rounded-xl border border-white/10 shadow-2xl" data-id="element-102" />
              </div>

              <a href={CHECKOUT_URL} aria-label="Comprar El Mapa de los Casi Algo por $6.39 USD" className="group block cursor-pointer p-8 transition-colors hover:bg-white/[0.02] focus:outline-none focus:ring-2 focus:ring-inset focus:ring-electric sm:p-10" data-id="element-103">
                <h2 className="font-display text-3xl font-semibold leading-tight text-cream sm:text-4xl" data-id="element-104">
                  Recupera tu paz mental
                </h2>
                <p className="mt-3 leading-relaxed text-muted" data-id="element-105">
                  Por menos de lo que cuesta una cena que hoy no puedes
                  disfrutar por la angustia.
                </p>

                <ul className="mt-6 space-y-3 text-sm text-muted" data-id="element-106">
                  <li className="flex items-center gap-2" data-id="element-107">
                    <CheckIcon className="h-4 w-4 flex-none text-electric" data-id="element-108" />
                    Acceso inmediato al "Mapa de los Casi Algo".
                  </li>
                  <li className="flex items-center gap-2" data-id="element-109">
                    <SmartphoneIcon className="h-4 w-4 flex-none text-electric" data-id="element-110" />
                    Léelo hoy mismo en tu teléfono o tablet.
                  </li>
                </ul>

                <div className="mt-8 flex flex-wrap items-end gap-x-4 gap-y-2" data-id="element-111">
                  <span className="font-display text-5xl font-semibold text-cream" data-id="element-112">
                    $6.39
                  </span>
                  <div className="mb-1.5 flex items-center gap-2" data-id="element-113">
                    <span className="text-base text-muted line-through" data-id="element-114">
                      $19.99
                    </span>
                    <span className="rounded-full bg-rose-glow/15 px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-rose-glow" data-id="element-115">
                      68% de descuento
                    </span>
                  </div>
                </div>
                <p className="mt-1 text-sm font-medium uppercase tracking-wide text-muted" data-id="element-116">
                  USD · Precio único
                </p>

                <span className="mt-7 inline-flex w-full items-center justify-center gap-3 rounded-full bg-rose-glow px-8 py-4 text-center text-sm font-bold uppercase tracking-wide text-white shadow-[0_18px_50px_-12px_rgba(232,69,95,0.7)] transition-colors group-hover:bg-rose-deep sm:w-auto sm:text-base" data-id="element-117">
                  QUIERO CERRAR EL CICLO AHORA
                  <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-118" />
                </span>

                <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-muted" data-id="element-119">
                  <span className="flex items-center gap-1.5" data-id="element-120">
                    <ShieldCheckIcon className="h-4 w-4 text-electric" data-id="element-121" /> Compra
                    segura
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-122">
                    <DownloadIcon className="h-4 w-4 text-electric" data-id="element-123" /> Descarga
                    instantánea
                  </span>
                  <span data-id="element-124">Comienza tu cierre hoy.</span>
                </div>
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}